import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/hikEvent`
//#region 基本信息
const GetList = `${apiUrl}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const PostHandle = `${apiUrl}/handle`
const GetNewEvents = `${apiUrl}/newEvents?h_np`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export class HikEventData {
    [key: string]: any
    Id: number
    EventId: string
    EventLvl: number
    EventType: number
    SrcIndex: string
    SrcParentIndex: string
    CameraIndexCode: string
    SrcType: string
    SrcName: string
    RegionIndexCode: string
    RegionName: string
    Status: number
    HappenTime: string
    StopTime: string
    NewDate: Date

    EventLvlName: string
    EventTypeName: string

    UnitId: number
    UnitCode: string
    PointId: number
    PointName: string
    DeviceId: number
    DeviceName: string

    PicList: HikEventPicData[]

    HandleStatus: number
    HandleStatusName: string
    HandleComments: string
    HandleDate: Date
    HandleBy: string
    constructor() {
        this.Id = 0
        this.EventId = ''
        this.EventLvl = 0
        this.EventType = 0
        this.SrcIndex = ''
        this.SrcParentIndex = ''
        this.CameraIndexCode = ''
        this.SrcType = ''
        this.SrcName = ''
        this.RegionIndexCode = ''
        this.RegionName = ''
        this.Status = 0
        this.HappenTime = ''
        this.StopTime = ''
        this.NewDate = new Date()

        this.EventLvlName = ''
        this.EventTypeName = ''

        this.UnitId = 0
        this.UnitCode = ''
        this.PointId = 0
        this.PointName = ''
        this.DeviceId = 0
        this.DeviceName = ''

        this.PicList = []

        this.HandleStatus = 0
        this.HandleStatusName = ''
        this.HandleComments = ''
        this.HandleDate = new Date()
        this.HandleBy = ''
    }
}
export class HikEventPicData {
    [key: string]: any
    Id: number
    EventId: string
    CameraIndexCode: string
    PicApi: string
    OrgPicId: number
    NewDate: Date
    constructor() {
        this.Id = 0
        this.EventId = ''
        this.CameraIndexCode = ''
        this.PicApi = ''
        this.OrgPicId = 0
        this.NewDate = new Date()
    }
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const postHandle = (form: any) => {
    return tryAxios({
        method: 'post',
        url: PostHandle,
        data: form
    })
}
export const getNewEvents = () => {
    return tryAxios({
        method: 'get',
        url: GetNewEvents,
    })
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}